<template>
  <div class="detalhe">
    <i class="fa-solid fa-magnifying-glass"></i>
  </div>
</template>
<script>
export default {
  props: ['altura'],
  components: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.detalhe {
  position: absolute;
  top: calc(50% - v-bind(altura));
  left: calc(50% - 20px);
  height: 60px;
  width: 60px;
  min-width: auto !important;
  color: white !important;
  -webkit-box-shadow: 0px 0px 42px 6px #e0a800;
  -moz-box-shadow: 0px 0px 42px 6px #e0a800;
  box-shadow: 0px 0px 42px 6px #e0a800;
  background: #e0a800;
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  //border: 1px solid white;
  cursor: pointer;
  i {
    margin-top: 25%;
    font-size: 30px;
    color: #282828 !important;
  }
}
</style>
